/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Api} from '../providers/api/api';


@Injectable()
export class AuthApiService extends Api {


    private base: string = this.getBaseUrl();

    /* call login api*/
    public doLogin(params: any): Observable<any> {
        return this.http.post(this.base + '/vendor/login', params);
    }

    /* call register api*/
    public doRegister(params: any): Observable<any> {
        return this.http.post(this.base + '/vendor/register', params);
    }

    /* call recover account api*/
    public doChangePassword(params: any): Observable<any> {
        return this.http.put(this.base + '/vendor/change-password', params);
    }

    /* call recover account api*/
    public doForgetPassword(params: {email: string}): Observable<any> {
        return this.http.get(this.base + `/vendor/forgot-password-link?email=${encodeURIComponent(params.email)}`);
    }

        // token status
    public tokenStatus(params: any): Observable<any> {
        const key = encodeURIComponent(params.key);
        return this.http.get(this.base + '/vendor/forgot-password-key-check/' + key, {params});
    }

           // set password
    public setpassword(params: any): Observable<any> {
        return this.http.put(this.base + '/vendor/reset-password', params);
    }

       /* call logout api*/
       public doLogout(params: any): Observable<any> {
        return this.http.get(this.base + '/vendor/logout', {params});
}
}
